module.exports = "<div class=\"example\">\n    <img src=\"<%-exampleImg%>\">\n</div>\n<form class=\"form-horizontal\">\n    <div class=\"form-group col-sm-10\">\n        <label class=\"control-label col-sm-2 col-sm-offset-2\">Title Text:</label>\n        <div class=\"col-sm-8\">\n            <input type=\"text\" class=\"form-control add-title\" placeholder=\"Enter Title Here\" value=\"<%- widget.getParamValue('TITLE_WIDGET_TITLE', '') %>\">\n        </div>\n    </div>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/reports/modify_widgets/titlewidget/titlewidget.html
// module id = 813
// module chunks = 7